import React from 'react'
import { Setters } from 'src/features/atoms/glove/japan/Components'
import { OrderPageTemplate } from 'src/Components/Domain/OrderPageTemplate'
import { catcherReducer } from 'src/features/atoms/glove/japan/slice/catcher'
import { State, PartialAction } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { BaseModelSelector } from 'src/Components/Domain/BaseModelSelector'
import { atomsBaseModel } from 'src/features/atoms/glove/japan/constants/baseModel'
import { useRouter } from 'next/router'
import { SET_FIGURE_PANEL_NUMBER } from 'src/features/atoms/glove/japan/constants/actionType'

const AtomsCatcher: React.FC = () => {
  const { t } = useLocale()
  const router = useRouter()
  const [state, dispatch] = React.useReducer(catcherReducer, t.INITIAL_STATE_C_MITT) as [State, React.Dispatch<PartialAction>]
  const { figurePanelNum } = state
  const handleFigurePanelNum = (_, newValue: 0 | 1) => dispatch({ ...state, type: SET_FIGURE_PANEL_NUMBER, figurePanelNum: newValue })
  const models = atomsBaseModel(t, router)
  return (
    <OrderPageTemplate
      breadcrumbTrail={`${t.HARD} / ATOMS / ${t.CATCHER}`}
      brand={'atoms'}
      {...{ figurePanelNum, state, dispatch, handleFigurePanelNum }}
    >
      <BaseModelSelector {...{ state, models, dispatch }} />
      <Setters {...{ state, figurePanelNum, dispatch }} />
    </OrderPageTemplate>
  )
}

export default AtomsCatcher
